"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _ProductItem = require("../../../../../Marketplace/Products/components/ProductItem");

var DefaultProducts = function DefaultProducts(_ref) {
  var products = _ref.products,
      onSelect = _ref.onSelect,
      value = _ref.value;
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    bgcolor: "common.white",
    p: 1,
    pb: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    color: "primary.main",
    fontSize: "14px",
    lineHeight: "16px",
    fontWeight: 700,
    mb: 2
  }, "Default Gift", products.length > 1 ? 's' : '', " for this Campaign"), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    spacing: 1
  }, products.map(function (product) {
    return /*#__PURE__*/_react.default.createElement(_material.Grid, {
      key: product.id,
      item: true,
      xs: 4
    }, /*#__PURE__*/_react.default.createElement(_ProductItem.ConnectedSelectableProductItem, {
      key: product.id,
      onClick: function onClick() {
        return onSelect(product);
      },
      id: product.id,
      denomination: product.denomination,
      sx: {
        height: '100%'
      },
      selected: product.id === (value === null || value === void 0 ? void 0 : value.id)
    }));
  })));
};

var _default = DefaultProducts;
exports.default = _default;